"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./Button.scss");
var React = require("react");
var BaseCta_1 = require("../BaseCta");
var ButtonProps_1 = require("./ButtonProps");
var Spinner_1 = require("../Spinner");
var Simplify_1 = require("../../../helpers/Functions/Simplify");
/**
 * A CTA that looks like a button. Will use `<button>` or `<a>` under the hood depending on the functionality needed.
 */
var Button = BaseCta_1.MakeCtaFromBase(function (allProps) {
    var _a = Simplify_1.simplify(allProps), _b = _a.arrow, arrow = _b === void 0 ? false : _b, icon = _a.icon, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = _a.kind, kind = _d === void 0 ? "primaryBlack" : _d, _e = _a.size, size = _e === void 0 ? "responsive" : _e, _f = _a.spinner, spinner = _f === void 0 ? false : _f, props = __rest(_a, ["arrow", "icon", "fullWidth", "kind", "size", "spinner"]);
    var accessoryClass = allProps.children && "add-margin-right";
    return {
        prepend: spinner ? (React.createElement(Spinner_1.default, { "aria-hidden": Boolean(allProps.children), className: accessoryClass })) : (!arrow && icon),
        classes: [
            ButtonProps_1.Size[size],
            ButtonProps_1.Kind[kind],
            fullWidth && ButtonProps_1.Classes.fullWidth,
            !spinner && arrow && ButtonProps_1.Classes.arrow,
        ],
        props: __assign(__assign({}, props), { role: "button" }),
    };
});
exports.default = Button;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Button/Button.js
// module id = 596
// module chunks = 8